<template>
  <div class="qr-card">
    <div class="link-content">
      <div class="blue_bg"></div>
      <div class="qr-content">
        <qriously class="qrcode" :value="qrcodeValue" :size="83" style="width: 100%" />
        <div class="name">{{ $t("header.lm-app") }}</div>
        <div class="s-name">{{ $t("header.scan-the-QR-code") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isLmDownloadHost } from "@/util/lm-download";
import { isQjDownloadHost } from "@/util/qj-download";

const CWJHK_HOSTS = ["cwjhk.com", "www.cwjhk.com", "m.cwjhk.com"];
const GDAILR_HOSTS = ["gdailr.com", "www.gdailr.com", "m.gdailr.com"];
const SEO_APP_DOMAIN_KEYS = [
  "tawld",
  "mkjaydx",
  "axpdael",
  "jxrheqv",
  "fiskids",
  "lpjnhgd",
  "prglqi",
  "wooydd",
  "dbrpu",
  "gpkvux",
  "eqszy",
  "xyuvjd",
  "gxmqt",
  "hjqks",
  "tkfkw",
  "dxhmc",
];

function getCurrentDownloadPageUrl() {
  if (typeof window === "undefined") return "";
  return `${window.location.origin}/download`;
}

function isSpecialDownloadDomain(host) {
  if (isLmDownloadHost(host) || isQjDownloadHost(host)) return true;
  if (CWJHK_HOSTS.includes(host) || GDAILR_HOSTS.includes(host)) return true;
  return SEO_APP_DOMAIN_KEYS.some((key) => host.indexOf(key) > -1);
}

export default {
  computed: {
    qrcodeValue() {
      const host =
        typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
      if (isSpecialDownloadDomain(host)) {
        return getCurrentDownloadPageUrl();
      }
      const h5Domain = this.$store.state.appConfig?.h5_domain;
      return h5Domain ? h5Domain + "download" : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.qr-card {
  width: 160px;
  box-shadow: 2px 2px 3px 0px rgba(142, 142, 142, 0.2);
  border-radius: 3px;
  position: absolute;
  top: 58px;
  right: 80px;
  z-index: 999;

  &:before {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    top: -16px;
    right: 58px;
    transform: translateX(-50%);
    border: solid 8px transparent;
    border-bottom: solid 8px #fff;
  }

  &:after {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    top: -11px;
    right: 58px;
    transform: translateX(-50%);
    border: solid 8px transparent;
    border-bottom: solid 8px #ffffff;
  }

  .blue_bg {
    width: 100%;
    // background: var(--theme-primary);
    height: 3px;
    position: relative;
  }

  .link-content {
    background-color: #ffffff;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    // padding: 13px 19px 0 19px;
  }

  .qr-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0;

    .qrcode {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .name {
      font-size: 15px;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
      padding: 10px;
    }

    .s-name {
      font-size: 14px;
      color: var(--theme-primary);
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      padding: 5px;
      padding-bottom: 0px;
    }
  }
}
</style>
